import { type FC } from 'react';
import cn from 'classnames';

import { timeStringFormat } from '@/common/lib/timer';

import { StatusDescription } from './StatusDescription';

import css from './styles.module.scss';

interface ContractTimerProps {
  timeLeft: number;
  hasWaitStatus?: boolean;
}

const ContractTimer: FC<ContractTimerProps> = ({ timeLeft, hasWaitStatus }) => {
  return (
    <StatusDescription
      className={cn('w-[5rem]', hasWaitStatus && css.waitTimer)}
      text={timeStringFormat(timeLeft * 1000, {
        template: '{hours}:{minutes}:{seconds}',
      })}
    />
  );
};

export { ContractTimer };
